import { jsx as t, Fragment as C, jsxs as v } from "react/jsx-runtime";
import { useState as A, useMemo as I, useCallback as $, useLayoutEffect as N } from "react";
import r from "./styles.module.less.js";
import E from "./logo.webp.js";
import { usePathname as D } from "../../../utils/use-pathname.js";
import { AccountLink as M } from "./account-link/index.js";
import { FLOATING_CONTAINER_ID as d } from "./index.js";
import { areasOfLawData as S } from "../../../constants.js";
import { convertToKebabCase as R } from "../../../utils/case-conversion.js";
import { DropdownMenuItemDesktop as T } from "./dropdown-menu-item/index.js";
import { MenuItem as k } from "./menu-item/index.js";
import { ForLawyersMenuButtonDesktop as B } from "./for-lawyers-button/index.js";
import { GetHelpMenuItemDesktop as H } from "./get-help-menu-item/index.js";
import { MenuChatButtonDesktop as P } from "./chat-button/index.js";
import { getRoute as U, RouteType as F } from "../../../utils/get-route.js";
import { LawyerViewButtons as O } from "./lawyer-view-buttons/index.js";
const _ = "/help", ae = (o) => {
  const {
    getTranslation: l,
    language: e,
    isLawyerSupported: h = !1,
    useWill: f = !1,
    lmpEnabled: w = !1,
    hideLinks: p = !1,
    lawyerView: y = !1,
    legalHubSupported: c = !1
  } = o, a = D(), [s, g] = A(!1), m = I(() => {
    const n = S[e];
    if (n)
      return [
        ...n.map((u) => ({
          ...u,
          path: `/${e}/${c ? "legal-hub" : "topics"}/${u.link ?? R(u.title)}`
        }))
      ];
  }, [e]), i = $(
    (n) => {
      switch (n) {
        case "/chat":
          return a === "/chat";
        case "/about":
          return a === `/${e}/about`;
        case "/about/company":
          return a === `/${e}/about/company`;
        case "/help":
          return a === _;
        case "/find":
          return a.endsWith(
            "/find"
            /* BROWSE_LAWYERS */
          );
        case "/legal-hub":
          return a === `/${e}/legal-hub`;
        case "/topics":
          return a === `/${e}/topics`;
        case "/account":
          return a === "/account";
        case "/for-lawyers/legal-network":
          return a === `/${e}/for-lawyers/legal-network`;
        case "/make-a-will":
          return a === U(F.WILL_INFO);
        default:
          return !1;
      }
    },
    [a, m, e]
  );
  return N(() => {
    const n = () => {
      var b, L;
      (window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0) > 80 ? ((b = document.getElementById(d)) == null || b.classList.add(r.shrink), g(!0)) : ((L = document.getElementById(d)) == null || L.classList.remove(r.shrink), g(!1));
    };
    return window.addEventListener("scroll", n), document.body.addEventListener("scroll", n), n(), () => {
      window.removeEventListener("scroll", n), document.body.removeEventListener("scroll", n);
    };
  }, []), /* @__PURE__ */ t(C, { children: /* @__PURE__ */ t("div", { className: r.floatingContainer, id: d, children: /* @__PURE__ */ v("div", { className: r.menuContentContainer, children: [
    /* @__PURE__ */ t(
      "a",
      {
        href: e ? `/${e}` : "/",
        className: r.logoContainer,
        children: /* @__PURE__ */ t(
          "img",
          {
            src: E,
            alt: "LawConnect Logo",
            width: 0,
            height: 20,
            className: r.logo
          }
        )
      }
    ),
    !p && y ? /* @__PURE__ */ t(
      O,
      {
        language: e,
        environment: o.environment
      }
    ) : !p && /* @__PURE__ */ v("div", { className: r.menuLinksContainer, children: [
      e === "en-au" ? /* @__PURE__ */ t(
        H,
        {
          language: e,
          titleLabel: l("pages.get-help"),
          getTranslation: l,
          hasShrunk: s,
          isLawyerSupported: h,
          onRequestLawyer: o.onRequestLawyer,
          isActive: i(
            "/help"
            /* HELP */
          ),
          newChatUrl: o.newChatUrl
        }
      ) : /* @__PURE__ */ t(
        P,
        {
          getTranslation: l,
          isScrolledHeader: s,
          language: e,
          newChatUrl: o.newChatUrl
        }
      ),
      h ? null : /* @__PURE__ */ t("div", { className: r.spacer }),
      w ? /* @__PURE__ */ t(
        k,
        {
          label: "Browse lawyers",
          path: e ? `/${e}/find` : "/find",
          hasShrunk: s,
          isActive: i(
            "/find"
            /* BROWSE_LAWYERS */
          )
        }
      ) : null,
      m ? /* @__PURE__ */ t(
        T,
        {
          language: e,
          items: m,
          titleLabel: c ? "Legal hub" : l("pages.legal-topics"),
          hasShrunk: s,
          link: c ? `/${e}/legal-hub` : `/${e}/topics`,
          classNames: {
            container: r.subMenuContainer,
            itemRow: r.offsetDropdownItemRow
          },
          isActive: i(
            c ? "/legal-hub" : "/topics"
            /* KNOWLEDGE_BASE */
          )
        }
      ) : null,
      w ? null : /* @__PURE__ */ t(
        k,
        {
          label: l("pages.about"),
          path: `/${e}/about/company`,
          hasShrunk: s,
          isActive: i(
            "/about/company"
            /* ABOUT_COMPANY */
          )
        }
      ),
      /* @__PURE__ */ t(
        B,
        {
          language: e,
          getTranslation: l,
          useWill: f,
          isScrolledHeader: s,
          isActive: i(
            f ? "/make-a-will" : "/for-lawyers/legal-network"
            /* FOR_LAWYERS */
          ),
          environment: o.environment
        }
      ),
      /* @__PURE__ */ t(
        M,
        {
          isScrolledHeader: s,
          isActive: i(
            "/account"
            /* ACCOUNT */
          ),
          isAuthenticated: o.isAuthenticated,
          userImage: o.userImage,
          openAuthModal: o.openAuthModal,
          logout: o.logout,
          hasNotifications: o.hasNotifications,
          language: e,
          getTranslation: l,
          newChatUrl: o.newChatUrl
        }
      )
    ] })
  ] }) }) });
};
export {
  ae as DesktopMenu
};
